import AirDatepicker from 'air-datepicker';
import localeNl from 'air-datepicker/locale/nl';
import { reverseAriaExpanded } from './utils';
import noUiSlider from 'nouislider';
import { initContentSliders } from '.';

const container = document.querySelector('.archive-container');

let archiveFilter;
let archiveFilterToggle;
let dateFilter;
let distanceFilter;
let datePicker;
let distanceSlider;
let filterOpen = false;
let filtering = false;

function isMobile() {
    return window.matchMedia('(max-width: 60em)').matches;
}

function initFilter() {
    archiveFilter = document.querySelector('.archive-filter');
    archiveFilterToggle = document.querySelector('.archive-filter-toggle');
    dateFilter = document.querySelector('.archive-filter-date');
    distanceFilter = document.querySelector('.archive-filter-distance');
    resetAllButton = document.querySelector('.archive-filter-reset-all');
    resetButtons = document.querySelectorAll('.archive-filter-reset-button');

    archiveFilter.addEventListener('submit', e => {
        e.preventDefault();
        executeFilter();
    });

    archiveFilter.addEventListener('change', e => {
        // When a subchoice is checked, uncheck the parent checkbox
        if (e.target.type === 'checkbox' && e.target.checked && e.target.closest('.archive-filter-subchoices')) {
            const parentChoice = e.target.closest('.archive-filter-subchoices').previousElementSibling;
            const parentCheckbox = parentChoice.querySelector('input[type="checkbox"]');
            parentCheckbox.checked = false;
        }

        if ((e.target.type === 'checkbox' || e.target.type === 'radio') && e.target.value !== 'custom' && !isMobile()) {
            executeFilter();
        }
    });
    
    archiveFilterToggle.addEventListener('click', () => {
        filterOpen = !filterOpen;
        reverseAriaExpanded(archiveFilterToggle);
        archiveFilter.classList.toggle('open', filterOpen);

        if (isMobile() && !filterOpen) {
            executeFilter();
        }
    });

    resetAllButton?.addEventListener('click', () => {
        resetFilter();
        executeFilter();
    });

    resetButtons?.forEach(button => {
        button.addEventListener('click', () => {
            resetFilter(button.dataset.name, button.dataset.value);
            executeFilter();
        });
    });

    if (dateFilter) {
        const dateInputText = dateFilter.querySelector('.archive-filter-date-input-text');
        const dateInputHidden = dateFilter.querySelector('.archive-filter-date-input-hidden');
        const datePresets = document.querySelector('.archive-filter-date-presets');

        function formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        };

        datePicker = new AirDatepicker(dateInputText, {
            locale: localeNl,
            range: true,
            isMobile: window.matchMedia('(max-width: 768px)').matches,
            autoClose: true,
            multipleDatesSeparator: ' - ',
            dateFormat: 'dd-MM-yyyy',
            onSelect({ date }) {
                if (date.length === 2) {
                    dateInputHidden.value = date.map(formatDate).join(',');
                } else if (date.length === 1) {
                    dateInputHidden.value = formatDate(date[0]);
                } else {
                    dateInputHidden.value = '';
                }
            },
            onHide() {
                setTimeout(() => {
                    !isMobile() && executeFilter();
                }, 200);
            }
        });

        if (dateInputHidden.value) {
            const dates = dateInputHidden.value.split(',');
            
            if (dates.length === 2) {
                datePicker.selectDate([new Date(dates[0]), new Date(dates[1])]);
            } else if (dates.length === 1) {
                datePicker.selectDate(new Date(dates[0]));
            }
        }

        datePresets.addEventListener('change', e => {
            if (e.target.value === 'custom') {
                dateFilter.classList.add('visible');
                datePicker.show();
            } else {
                resetAndHideDatePicker();
            }
        });
    }

    if (distanceFilter) {
        const container = distanceFilter.querySelector('.archive-filter-distance-slider');
        const minInput = distanceFilter.querySelector('.archive-filter-distance-min');
        const maxInput = distanceFilter.querySelector('.archive-filter-distance-max');
        const minDefault = 0;
        const maxDefault = parseInt(maxInput.getAttribute('max'));
        const minValue = parseInt(minInput.value);
        const maxValue = parseInt(maxInput.value);

        let distanceTimeout;

        distanceSlider = noUiSlider.create(container, {
            start: [minValue, maxValue],
            connect: true,
            range: {
                min: minDefault,
                max: maxDefault,
            },
            format: {
                to: value => parseInt(value),
                from: value => parseInt(value),
            },
            step: 1,
        });

        distanceSlider.on('update', function (values, handle) {
            if (handle === 0) {
                minInput.value = values[handle];
            } else if (handle === 1) {
                maxInput.value = values[handle];
            }
        });

        distanceSlider.on('set', function (values) {
            if (distanceTimeout) {
                clearTimeout(distanceTimeout);
            }

            distanceTimeout = setTimeout(() => {
                !isMobile() && executeFilter();
            }, 200);
        });

        distanceSlider.reset = function () {
            distanceSlider.set([minDefault, maxDefault]);
        };
        
        minInput.addEventListener('input', function () {
            distanceSlider.set([this.value, null]);
        });

        maxInput.addEventListener('input', function () {
            distanceSlider.set([null, this.value]);
        });
    }
}

function executeFilter() {
    if (filtering) return;
    filtering = true;

    const queryString = new URLSearchParams(new FormData(archiveFilter)).toString();
    const url = archiveFilter.action + '?' + queryString;

    container.classList.add('loading');
    history.pushState({}, '', url);

    fetch(url)
        .then(response => response.text())
        .then(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;

            const newContainer = temp.querySelector('.archive-container');

            if (newContainer) {
                container.innerHTML = newContainer.innerHTML;
            }

            initContentSliders(container);
            initFilter();

            container.classList.remove('loading');
            archiveFilter.classList.remove('open');

            filtering = false;
        });
}

function resetFilter(name = '', value = '') {
    const selector = name ? `[name="${name}"]` : 'input, select';

    archiveFilter.querySelectorAll(selector).forEach(input => {
        if ((input.type === 'checkbox' || input.type === 'radio') && (!value || input.value === value)) {
            input.checked = false;
        }

        if (['text', 'date', 'search'].includes(input.type)) {
            input.value = '';
        }
    });

    if (!name || name === 'ec_period') {
        resetAndHideDatePicker();
    }

    if (!name || name === 'ec_distance') {
        resetDistanceSlider();
    }
}

function resetAndHideDatePicker() {
    if (!datePicker) {
        return;
    }

    datePicker.clear();

    if (datePicker.visible) {
        datePicker.hide();
    }

    dateFilter.classList.remove('visible');
}

function resetDistanceSlider() {
    if (!distanceSlider) {
        return;
    }

    distanceSlider.reset(); // Does this work? No idea
}

initFilter();